import script from "./Category.vue?vue&type=script&setup=true&lang=ts"
export * from "./Category.vue?vue&type=script&setup=true&lang=ts"

import "./Category.vue?vue&type=style&index=0&id=0fa069b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa069b0"]])

export default __exports__